function resizeWindow(){
    if($(window).width() > 800){
        //Primary nav and logo
        var padSide = ($('#header .logo').outerWidth() + 40 ) / 2;
        $('#header .left').css('padding-right',padSide);
        $('#header .right').css('padding-left',padSide);

        $('.blog-list .item:nth-child(even)').each(function(){
            $(this).find('.info').insertBefore($(this).find('.images'));
        });
    } else{
        $('.blog-list .item').each(function(){
            $(this).find('.info').insertAfter($(this).find('.images'));
        });
    }

    if($('#home .top-content .header-img img').height() > $(window).height()){
        $('#home .top-content .header-img').height($(window).height());
    }else{
        $('#home .top-content .header-img').css('height','auto');
    }
}
function scrollDown(){
    var top = $(document).scrollTop();
    if (top > 50) {
        $('#home #header').addClass('down');
        $('.arrow-scroll').fadeOut();
        $('.subfooter.otherpages').fadeOut();
    } else {
        $('#home #header').removeClass('down');
        $('.arrow-scroll').fadeIn();
    }
}

$(document).ready(function () {

    //Call function with browser is resized.
    $(window).resize(function (event) {
        resizeWindow();
    });


    //Acts when scroll down page.
    $(window).scroll(function (event) {
        scrollDown();

    });

    if(!$('body#home').length > 0){
        $('#header').addClass('down'); 
        $('.subfooter').addClass('otherpages');
    }

    //main Nav
    var contcheck = 0
    $('#header #primary-nav ul li').each(function(){
        if(contcheck < 3){
            $(this).addClass('checked');
            contcheck++;
        }
    });

    //Fancybox iframe
    $(".fancyboxIframe").fancybox({
        maxWidth	: 1200,
        maxHeight	: 670,
        fitToView	: false,
        width		: '90%',
        height		: '90%',
        autoSize	: false,
        closeClick	: false,
        openEffect	: 'none',
        closeEffect	: 'none',
        padding : 0,
        iframe: {
            scrolling : 'auto',
            preload   : true
        }
    })

    $(".gallery-fancybox").fancybox();



    // $('#header #primary-nav ul li.checked').wrapAll('<div class="left"></div>');
    // $('#header #primary-nav ul li:not(.checked)').wrapAll('<div class="right"></div>');
    // $('#header #primary-nav ul li').removeClass('checked');

     //Booking
    // $('.reserve-btn').click(function(){
    //     $('#booking-form').addClass('open');
    // });
    // $('#booking-form .top .close').click(function(){
    //     $('#booking-form').removeClass('open');
    // });


     // Main Nav Dropdown
    $("#privary-navigation li").hover(function () {
        $(this).addClass("hover");
        $('ul.submenu', this).fadeIn(200);
    }, function () {
        $(this).removeClass("hover");
        $('ul.submenu', this).fadeOut(200);
    });

    //Home page scroll down arrow. If present.
    $('.arrow-scroll').click(function(event) {
        $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
            1400, 'easeOutExpo');
        $(this).fadeOut();
    });

    //home instagram gallery
    $('.home-instagram .instagram_gallery .instagram.first_half').wrapAll('<div class="f_group"></div>');
    $('.home-instagram .instagram_gallery .instagram.second_half').wrapAll('<div class="s_group"></div>');
    $('.home-instagram .instagram_gallery .f_group').prev('.instagram').insertBefore($('.home-instagram .instagram_gallery .f_group .first_half:first-child'));
    $('.home-instagram .instagram_gallery .s_group').prev('.instagram').insertBefore($('.home-instagram .instagram_gallery .s_group .second_half:first-child'));
    $('.home-instagram .instagram_gallery .f_group .first_half').wrapAll('<div class="group"></div>');
    $('.home-instagram .instagram_gallery .s_group .second_half').wrapAll('<div class="group"></div>');


    //Event Tracking
    $('.book-now').on('click', function () {
        if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
    });
    $('.bookNow').on('click', function () {
        if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
    });

    var picker = $('#end-dinner').datetimepicker({
        pickDate: false,
        language: 'en',
        pickSeconds: false,
        pick12HourFormat: true
    });

    //Check in and check out datepicker for booking engine
    $( "#CheckIn" ).datepicker({
        //showOn: "both",
        //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
        //buttonImageOnly: true,
        changeMonth: true,
        //changeYear: true,
        numberOfMonths: 1,
        minDate: 0,
        dateFormat: 'yy-mm-dd',
        onSelect: function( selectedDate ) {
            getDate = $(this).datepicker('getDate');
            newDate = new Date(getDate.getTime());
            newDate.setDate(newDate.getDate() + 3);
            $( "#CheckOut" ).datepicker( "setDate", newDate );
            $( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
            showNewDate();
        }
    });
    $( "#CheckOut" ).datepicker({
        //showOn: "both",
        //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
        //buttonImageOnly: true,
        changeMonth: true,
        dateFormat: 'yy-mm-dd',
        numberOfMonths: 1,
        onSelect: function( selectedDate ) {
            $( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
            showNewDate();
        }
    });

    //function timepicker shortcode
    $('#datetimepicker3').datetimepicker({
        pickDate: false,
        language: 'en',
        pickSeconds: false,
        pick12HourFormat: true
    });
    $('#datetimepicker4').datetimepicker({
        pickDate: false,
        language: 'en',
        pickSeconds: false,
        pick12HourFormat: true
    });



    showNewDate();


    $('.guests select').on('change', function() {
        $(this).next('.simulator').html(this.value);
    });

    if($('body.map').length > 0){
        $('.subfooter').hide();
    }
    // Map: Return to previous page button. Change body id to match map template's name.
    //$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

    /*ON SCROLL CONTENT ANIMATION*/
    setTimeout(function() {
        var controller = new ScrollMagic.Controller();
        if($('.animatetplace_one').length > 0) {
            $('.animatetplace_one').each(function(){
                // build a scene
                var ourScene = new ScrollMagic.Scene({
                    triggerElement: this.children[0],
                    triggerHook: 0.9,
                    reverse:false
                })
                    .setClassToggle(this, 'fade-in')
                    .addTo(controller);
            });
        }
    }, 600);

    setTimeout(function() {
        var controller = new ScrollMagic.Controller();
        if($('.animatetplace_two').length > 0) {
            $('.animatetplace_two').each(function(){
                // build a scene
                var ourScene = new ScrollMagic.Scene({
                    triggerElement: this.children[0],
                    triggerHook: 0.9,
                    reverse:false
                })
                    .setClassToggle(this, 'fade-in')
                    .addTo(controller);
            });
        }
    }, 1500);

    setTimeout(function() {
        var controller = new ScrollMagic.Controller();
        if($('.animatetplace_three').length > 0) {
            $('.animatetplace_three').each(function(){
                // build a scene
                var ourScene = new ScrollMagic.Scene({
                    triggerElement: this.children[0],
                    triggerHook: 0.9,
                    reverse:false
                })
                    .setClassToggle(this, 'fade-in')
                    .addTo(controller);
            });
        }
    }, 2400);
    
    setTimeout(function() {
        var controller = new ScrollMagic.Controller();
        if($('.animatetplace_four').length > 0) {
            $('.animatetplace_four').each(function(){
                // build a scene
                var ourScene = new ScrollMagic.Scene({
                    triggerElement: this.children[0],
                    triggerHook: 0.9,
                    reverse:false
                })
                    .setClassToggle(this, 'fade-in')
                    .addTo(controller);
            });
        }
    }, 3600);

    var siteli = $('ul.global-sitemap > li').length;
    var cont = 0;
    $('ul.global-sitemap > li:not(.checked)').each(function(){
        if(cont < siteli){
            $(this).addClass('checked');
        }
        cont = cont + 2;
    });
    $('ul.global-sitemap > li.checked').wrapAll('<div class="col-md-6"></div>');
    $('ul.global-sitemap > li:not(.checked)').wrapAll('<div class="col-md-6"></div>');
    $('ul.global-sitemap > li').removeClass('checked');
    $('ul.global-sitemap').addClass('clearfix');


    if($('body.harbour-island').length > 0){
        $('.island-block .blog-list .item:nth-child(even)').each(function(){
            $(this).find('.info').insertBefore($(this).find('.images'));
        });
        $('.shortcode .wrapper > p').hide();
    }


    /*$('.read-more').click(function(){
        $('.has-blog .full-desc').slideDown(600);
        $('.has-blog .short-desc').hide();
        $(this).fadeOut();
    });*/

    $('.blog-list').next('p').hide();
    $('.blog-list').prev('p').hide();

});

$(window).on('load', function() {

    resizeWindow();
    scrollDown();

    //Slick Slider
    $('.sym-slides').slick();

    $('#home .top-reasons .images-block').slick({
        arrows:true,
        dots:true,
        fade:true,
        asNavFor: '#home .top-reasons .info-block .block',
        accessibility:false
    });
    $('#home .top-reasons .info-block .block').slick({
        arrows:false,
        fade:true,
        asNavFor: '#home .top-reasons .images-block',
        accessibility:false
    });
    //reasons counter
    var nreasons = $('#home .top-reasons ul.slick-dots li').length;
    $('#home .top-reasons ul.slick-dots li').each(function(){
        var ctext = $(this).find('button').text() + '/' + nreasons;
        $(this).find('button').text(ctext);
    });

    $('#home .home-experiences .info .text .allexperiences').slick({
        arrows:true,
        dots:true,
        fade:true,
        accessibility:false
    });
    //experiences counter
    var nreasons = $('#home .home-experiences .allexperiences ul.slick-dots li').length;
    $('#home .home-experiences .allexperiences ul.slick-dots li').each(function(){
        var ctext = $(this).find('button').text() + '/' + nreasons;
        $(this).find('button').text(ctext);
    });

    $('ul.accommodations li.room .image').slick({
        arrows:true,
        fade:true,
        autoplay:true,
        autoplaySpeed:4000,
        prevArrow:$('ul.accommodations .preview .prev'),
        nextArrow:$('ul.accommodations .preview .next'),
        accessibility:false
    });

    $('.island-block .blog-list .item .images').slick({
        arrows:true,
        dots:true,
        fade:true,
        accessibility:false
    });
    //images counter
    var nreasons = $('.island-block .blog-list .item .images ul.slick-dots li').length;
    $('.island-block .blog-list .item .images ul.slick-dots li').each(function(){
        var ctext = $(this).find('button').text() + '/' + nreasons;
        $(this).find('button').text(ctext);
    });

    //images list

    $('.blog-list .item .images').slick({
        arrows: true,
        dots: true,
        fade : true,
        accessibility : false
    });
    //images counter
    var nlisti = $('.blog-list .item .images ul.slick-dots li').length;
    $('.blog-list .item .images ul.slick-dots li').each(function(){
        var ctext = $(this).find('button').text() + '/' + nlisti;
        $(this).find('button').text(ctext);
    });


});

function showNewDate(){
    var months = [ "months","Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
    var checkin = $('#CheckIn').attr('value').split('-');
    var checkout = $('#CheckOut').attr('value').split('-');

    var checkinDay = checkin[2];
    var checkoutDay = checkout[2];

    if (checkin[1].indexOf("0") == 0){
        var inmonth = checkin[1].split('0')[1];
    } else {
        var inmonth = checkin[1];
    }

    if (checkout[1].indexOf("0") == 0){
        var outmonth = checkout[1].split('0')[1];
    } else {
        var outmonth = checkout[1];
    }



    var checkinMonth = months[inmonth];
    var checkoutMonth = months[outmonth];



    // $('#booking-form .form-entry .date:first-child .simulator').html(checkinDay+'<br><span>'+checkinMonth+'</span>');
    // $('#booking-form .form-entry .date:last-child .simulator').html(checkoutDay+'<br><span>'+checkoutMonth+'</span>');

}

equalize();

//add dinner reservation
var nextinput = 0;

function AgregarCampos(){
    nextinput++;
    $("#campos").addClass('show_campos').append('<div class="col-md-4"><div class="field"><label for="restaurant'+nextinput+'">Restaurant:</label><select name="restaurant'+nextinput+'" id="restaurant'+nextinput+'" size="1"><option selected="selected" value="">Select Option</option><option value="The Dunmore">The Dunmore</option><option value="The Landing">The Landing</option><option value="Runaway Hill">Runaway Hill</option><option value="The Rock House">The Rock House</option><option value="Ocean View">Ocean View</option><option value="Coral Sands">Coral Sands</option><option value="Pink Sands">Pink Sands</option><option value="DaVine Sushi Restaurant">DaVine Sushi Restaurant</option><option value="Valentines Boat House Restaurant">Valentines Boat House Restaurant</option></select></div></div><div class="col-md-4"><div class="field"><label for="date-dinner'+nextinput+'">Date:</label><input id="date-dinner'+nextinput+'" name="date-dinner'+nextinput+'" placeholder="mm/dd/yyyy" class="date-dinner textfield date-begin update-blocks datepicker" maxlength="10"></div></div><div class="col-md-4"><div class="field"><label for="end_dinner'+nextinput+'">Time:</label><div class="well"><div id="end-dinner-add'+nextinput+'" class="input-append end-dinner-add"><input data-format="HH:mm PP" placeholder="hh:mm" type="text" maxlength="8" name="end_dinner'+nextinput+'" id="end_dinner'+nextinput+'"></input><span class="add-on"><i data-time-icon="icon-time" data-date-icon="icon-calendar"></i></span></div></div></div></div><div class="duplicate"><div class="col-md-4"><div class="field"><label for="guest'+nextinput+'">Number of Guest:</label><input name="guest'+nextinput+'" id="guest'+nextinput+'" type="text"></div></div><div class="col-md-4"><div class="field"><label for="children'+nextinput+'">Number of Children:</label><input name="children'+nextinput+'" id="children'+nextinput+'" type="text"></div></div><div class="col-md-4"><div class="field"><label for="age'+nextinput+'">Age:</label><input name="age'+nextinput+'" id="age'+nextinput+'" type="text"></div></div></div>');
    $(".date-dinner").datepicker();
    $(".time-dinner").datepicker();
    $(".end-dinner-add").datetimepicker({
        pickDate: false,
        language: 'en',
        pickSeconds: false,
        pick12HourFormat: true
    });



    showNewDate();

};

// Msg form select
function msgoption() {
  document.getElementById("select-option").innerHTML = "Yoga classes are offered complimentary for our guest at The Dunmore two times per week, Tuesday and Thursday from 8:30am – 9:30am";
}
var optionval = 'YOGA';
$("select#cart").change(function() {
    if ($(this).val() == optionval ) {
        msgoption();
        $('#select-option').removeClass('hidden');
    } else if ($(this).val() != optionval ) {
        $('#select-option').addClass('hidden');
    } 
});
